export const NEWS = [
  {
    id: "partnership-enquiries-open",
    date: "2026-06-15",
    category: "Announcement",
    title: "OpenDegree opens partnership enquiries for UK universities",
    excerpt:
      "We're now welcoming our first university and higher education partners ahead of our public launch. Institutions can register their interest via our partnership page.",
  },
  {
    id: "myae-partnership",
    date: "2026-06-02",
    category: "Partnership",
    title: "OpenDegree partners with MyAE",
    excerpt:
      "We're bringing AI-powered academic feedback into the OpenDegree ecosystem, helping students improve their assignments before they submit.",
  },
  {
    id: "built-around-real-admissions",
    date: "2026-05-20",
    category: "Platform Update",
    title: "Building around real admissions processes",
    excerpt:
      "We're working closely with UK institutions to ensure the platform is built around how admissions actually work — for both universities and students.",
  },
  {
    id: "the-team-behind-opendegree",
    date: "2026-05-05",
    category: "Company News",
    title: "The team behind OpenDegree",
    excerpt:
      "A multidisciplinary team is building the future of higher education admissions through AI, intelligent automation and human-centred technology.",
  },
];

export const CATEGORY_STYLE = {
  Announcement: "bg-cobalt/10 text-cobalt",
  Partnership: "bg-indigo-50 text-indigo-600",
  "Platform Update": "bg-emerald-50 text-emerald-600",
  "Company News": "bg-amber-50 text-amber-600",
};

export const formatNewsDate = (iso) =>
  new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
